<template>
  <div class="py-4" @mouseenter="ensureOptions" @focusin="ensureOptions">
    <SmSelect
      v-model:selection="selection"
      :options="lazyOptions"
      :label="props.license.email"
      trigger-style="round"
      trigger-size="small"
      dropdown-min-width="300px"
      @change="(newVal) => handleAliasChange(newVal)" />
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'

  import { Account, LicenceOut, UserAliasesService } from '@/client'

  import { editToast, sendToast } from '@/components/sm/SmNotification'
  import { Option } from '@/components/sm/SmSelect.vue'

  const i18n = useI18n()

  const props = defineProps({
    license: { type: Object as PropType<LicenceOut>, required: true },
    getOptions: {
      type: Function as PropType<() => Option<string>[]>,
      required: true,
    },
  })

  const emit = defineEmits(['update:selection', 'licenseChanged'])

  const selection = ref<Option<string>[]>([])

  const lazyOptions = ref<Option<string>[]>([])
  let loaded = false

  const ensureOptions = () => {
    if (loaded) return
    loaded = true
    lazyOptions.value = props.getOptions()
  }

  function handleAliasChange(newAlias: Option<string>[] | undefined) {
    if (!newAlias) return
    const toastId = sendToast(
      i18n.t('notification.loading'),
      undefined,
      'loading'
    )

    UserAliasesService.addAliasApiV1ManagementUsersEmailOrIdAliasPost({
      // Current email
      emailOrId: newAlias[0].value,
      requestBody: {
        // Username that should be added to the account
        user_name: props.license.email,
      },
    })
      .then(() => {
        emit('licenseChanged'),
          editToast(toastId, {
            title: i18n.t('alias.addAliasSuccess'),
            message: '',
            type: 'success',
          })
      })
      .catch(() => {
        editToast(toastId, {
          title: i18n.t('notification.loadingError'),
          message: '',
          type: 'error',
        })
      })
  }
</script>
